// extracted by mini-css-extract-plugin
export default {"antModal":"waypoint_delete_modal__antModal--f1Sm","buttonAndHeader":"waypoint_delete_modal__buttonAndHeader--R8Vi"};